import React, { MouseEventHandler } from 'react';

import { Tooltip } from '@uikit/components/Tooltip';

import { TokenBalance } from '@shared/helpers/web3/getUserTokenBalance';

export interface SwapMaxBalanceButtonProps {
  maxButtonTooltipContent: string;
  putMaxTokenAmount: MouseEventHandler<HTMLButtonElement>;
  fromTokenBalance: TokenBalance;
}

const SwapMaxBalanceButton = ({
  maxButtonTooltipContent,
  putMaxTokenAmount,
  fromTokenBalance,
}: SwapMaxBalanceButtonProps) => {
  return (
    <Tooltip
      content={{
        title: '',
        content: maxButtonTooltipContent,
      }}
      disabled={!maxButtonTooltipContent || !fromTokenBalance.balance}
      trigger={
        <button
          onClick={putMaxTokenAmount}
          onMouseDown={putMaxTokenAmount}
          disabled={!fromTokenBalance.balance}
          className="button button-sm h-fit w-fit button-primary bg-primary text-neutral-50 py-0.5 px-2 rounded max-sm:text-[8px]"
        >
          MAX
        </button>
      }
    />
  );
};

export default SwapMaxBalanceButton;
